import { Component, OnInit } from '@angular/core';
import { DropdownItem } from 'mis-crystal-design-system/dropdown';
import { AuthService } from 'src/app/shared/services/auth.service';
import { CommonService } from 'src/app/shared/services/common.service';
import { BookingsViewService } from '../bookings-view/bookings-view.service';
import { CommonBillingService } from 'src/app/billing/shared/common-billing.service';

@Component({
  selector: 'app-ava',
  templateUrl: './ava.component.html',
  styleUrls: ['./ava.component.scss']
})
export class AvaComponent implements OnInit {

  searchInput = '';
  showApproverList = false;
  cities: DropdownItem[];
  bookingType: DropdownItem[];
  bookingTypeList: any;
  timeout: DropdownItem[] = [
    {
      label: '5 minutes',
      value: '5 minutes'
    },
    {
      label: '10 minutes',
      value: '10 minutes'
    },
    {
      label: '15 minutes',
      value: '15 minutes'
    },
    {
      label: '30 minutes',
      value: '30 minutes'
    },
    {
      label: '60 minutes',
      value: '60 minutes'
    },
    {
      label: '120 minutes',
      value: '120 minutes'
    }
  ];
  citylist: any;
  vendorList: any;
  filtererdVendorList: any[] = [];
  alteredList = [];
  firstCity = '';
  firstBookingType = '';
  selectedBookingType = '';
  selectedCity = '';
  timeoutTime = 'Acceptance Timeout';
  isChangeMade: boolean;
  isTimeSelected: boolean = true;
  showTimeoutError = false;
  approverPopup = false;
  approverSearch = '';
  approverList: any;
  filteredApproverList: any[];
  approverEmail = '';
  toastMsg = '';
  successToast = false;
  showSaveConfigWarning = false;
  showMandatoryApprover = false;
  showPercentageError = false;
  showSortedData = false;
  configApproval = false;
  percentSum = 0;
  vendorPercentMap: any = new Map();
  approvalRolesForAVA: [];
  public bookingTypeConfig: any;
  public cityConfig: any;
   public bookingFilterConfig: any;
    public config: any;
    acceptanceTimeOut: any;

  constructor(private commonService: CommonService,
              private bookingViewService: BookingsViewService,
              private authService: AuthService,
              private commonBillingService: CommonBillingService) { }

  ngOnInit(): void {
    this.commonService.fetchConfig().subscribe((response: any) => {
      this.config = this.commonService.getConfigForElementKey(response, 'Booking View Page');
      this.bookingFilterConfig = this.commonService.getConfigForElementKey(this.config, 'Filter Section');

      this.bookingTypeConfig = this.commonService.getConfigForElementKey(this.bookingFilterConfig, 'AVA Booking Type');
      this.cityConfig = this.commonService.getConfigForElementKey(this.bookingFilterConfig, 'City');
      this.citylist = this.cityConfig.config.values;
      this.bookingTypeList = this.bookingTypeConfig.config.values;
      this.bookingType = this.bookingTypeList.map((item: any) => ({
      label: item,
      value: item
     })).filter(item => {
      return item.label !== "All";
    });

      this.cities = this.citylist.map((item: any) => ({
      label: item,
      value: item,
    })).filter((item) => {
      return item.label !== "All";
    }).sort(
      (a, b) => (a.label > b.label) ? 1 : (a.label < b.label) ? -1 : 0
    );
      this.firstCity = this.cities[0].label;
      this.bookingViewService.cityName.next(this.firstCity);
      this.bookingViewService.cityName.subscribe(res => this.selectedCity = res);
      this.firstBookingType = this.bookingType[0].label;
      this.bookingViewService.bookingType.next(this.firstBookingType);
      this.bookingViewService.bookingType.subscribe(res => this.selectedBookingType = res);
      this.setVendorList();
    });

    this.commonService.fetchMiscConfig().subscribe(res =>
      this.approvalRolesForAVA = res.approvalRolesForAVA
    );

  }

  setVendorList() {
    this.bookingViewService.fetchVendorConfig().subscribe(res => {
      this.vendorList = res.autoVendorAllocations;
      this.acceptanceTimeOut = res.acceptanceTimeOut;
      this.timeoutTime = `${this.acceptanceTimeOut} minutes`;
      this.filtererdVendorList = this.vendorList;
      this.percentSum = 0;
      this.filtererdVendorList.forEach(vendor => {
        this.percentSum += parseInt(vendor.allocationPercentage);
        this.vendorPercentMap.set(vendor.vendorId, parseInt(vendor.allocationPercentage));
      });

      if(!this.acceptanceTimeOut){
        this.isTimeSelected = false;
      }
    });

    this.isChangeMade = false;
  }

  selectVendorCity(event) {
    if (this.alteredList.length == 0) {
      this.firstCity = event.label;
      this.selectedCity = event.label;
      this.bookingViewService.cityName.next(event.label);
      this.setVendorList();
    }
    else {
      this.showSaveConfigWarning = true;
    }
  }

  selectBookingType(event){
     if (this.alteredList.length == 0){
      this.firstBookingType = event.label;
      this.selectedBookingType = event.label;
      this.bookingViewService.bookingType.next(event.label);
      this.setVendorList();
     } else {
     this.showSaveConfigWarning = true;
     }
  }

  percentChange(vendor, percentage) {
    this.percentSum = this.percentSum - this.vendorPercentMap.get(vendor.vendorId) + parseInt(percentage);
    this.isChangeMade = true;

    this.vendorList.forEach(item => {
      if (item.vendorName == vendor.vendorName) {
        const index = this.alteredList.findIndex((e) => e.vendorId === vendor.vendorId);
        if (index === -1){
          this.alteredList.push({
            vendorName: vendor.vendorName,
            allocationPercentage: percentage,
            vendorId: item.vendorId,
          });
        }
        else{
          this.alteredList[index].allocationPercentage = percentage;
        }
      }
    });
    this.vendorPercentMap.set(vendor.vendorId, parseInt(percentage));
  }

  onSearchInputChange(value) {
    this.filtererdVendorList = this.vendorList.filter(vendor => {
      if (vendor.vendorName.toLowerCase().includes(value.toLowerCase())) {
        return vendor;
      }
    });
  }

  selectTimeout(e) {
    this.timeoutTime = e.label;
    this.isTimeSelected = true;
    this.alteredList.forEach(vendor =>
      vendor["timeProposed"] = parseInt(e.label.split(" ")[0]));
  }

  onSave() {
    this.filtererdVendorList.forEach(vendor => {
      if (vendor.notEditable == true) {
        this.configApproval = true;
        this.toastMsg = `Configuration change approval for ${this.selectedCity} is still pending.`;
      }
      setTimeout(() => {
        this.configApproval = false;
      }, 3000);

    });

    if (this.percentSum !== 100 && this.alteredList.length > 0) {
      this.showPercentageError = true;
      this.toastMsg = "Allotment percentage should be 100%";
      setTimeout(() => {
        this.showPercentageError = false;
      }, 3000);
    }
    else if (!this.isTimeSelected) {
      this.showTimeoutError = true;
      this.toastMsg = "Please select an acceptance timeout";
      setTimeout(() => {
        this.showTimeoutError = false;
      }, 3000);
    }
    else if (this.isTimeSelected && this.alteredList.length == 0 && !this.configApproval){
      this.bookingViewService.fetchConfigApprover(this.approvalRolesForAVA).subscribe(res => {
        this.approverList = res;
        this.filteredApproverList = this.approverList;
        if(this.authService?.user?.role !== 'SITE_ADMIN'){
          this.approverPopup = true;
        } else {
          this.submitVendorConfigUpdate();
        }
      });
    }
    else if (this.isChangeMade && this.isTimeSelected && !this.configApproval) {
      this.bookingViewService.fetchConfigApprover(this.approvalRolesForAVA).subscribe(res => {
        this.approverList = res;
        this.filteredApproverList = this.approverList;
        if(this.authService?.user?.role !== 'SITE_ADMIN'){
          this.approverSearch = "";
          this.approverPopup = true;
        } else {
          this.submitVendorConfigUpdate();
        }
      });
    }

  }

  onSearchApproverChange(event) {
    if (event != '') {
      this.showApproverList = true;
      this.filteredApproverList = this.approverList.filter(approver => {
        if (approver.name.toLowerCase().includes(event.toLowerCase())) {
          return approver;
        }
      });
    }
    else { this.showApproverList = false; }
  }


  selectedApprover(selected) {
    this.approverEmail = selected.email;
    this.approverSearch = selected.name;
    this.showMandatoryApprover = false;
    this.alteredList.forEach(vendor => vendor["approver"] = this.approverEmail);
    this.showApproverList = false;
  }

  submitVendorConfigUpdate() {
   if (this.alteredList.length != 0){
    this.alteredList.forEach((item) => {
      item['city'] = this.selectedCity,
      item['bookingType'] = this.selectedBookingType;
      item['proposer'] = this.authService.user.employeeGuid;
    });
    if(this.authService?.user?.role === 'SITE_ADMIN'){
      this.alteredList.forEach(vendor => vendor["approver"] = "");      
    }
  }
  const body = {
    acceptanceTimeOut: parseInt(this.timeoutTime.split(' ')[0]),
    autoVendorAllocations: this.alteredList.length == 0 ? [] : this.alteredList
  };
  
   if(this.authService?.user?.role !== "SITE_ADMIN" && this.approverSearch == '') { 
    this.showMandatoryApprover = true; 
  } else {
      this.bookingViewService.saveVendorConfig(body, this.selectedCity, this.selectedBookingType).subscribe((res) => {
        if (res == 'Request successfully submitted') {
          this.successToast = true;
          this.toastMsg = 'Request successfully submitted';
          setTimeout(() => {
            this.successToast = false;
          }, 3000);
        }
      });
      this.approverPopup = false;
      this.setInitialConditions();
    }
  }

  setInitialConditions() {
    this.searchInput = '';
    this.alteredList = [];
    this.setVendorList();
    this.firstCity = this.cities[0].label;
    this.timeoutTime = `${this.acceptanceTimeOut} minutes`;
    this.showSaveConfigWarning = false;
    this.firstBookingType = this.bookingType[0].label;
  }

  sortData() {
    this.showSortedData = !this.showSortedData;
    this.showSortedData ?
      this.filtererdVendorList.sort((a, b) => b.allocationPercentage - a.allocationPercentage) : this.filtererdVendorList.sort((a, b) => a.allocationPercentage - b.allocationPercentage);
  }

  clearUpdate() {
    this.approverSearch = "";
    this.alteredList.forEach(vendor =>
      vendor["approver"] = "");
  }

  makeButtonSubmitEnable() {
    this.showSaveConfigWarning = false;
    this.onSave();
  }

  async downloadAVAConfiguration(){
    this.toastMsg = "Report will be downloaded in sometime, please don't close the window."; 
    
    this.successToast = true;
    const timeoutRef = setTimeout(() => {
      this.successToast = false;
    }, 3000);

    this.commonService.fetchAVAConfig().subscribe((res)=>{
      if(res){
        clearTimeout(timeoutRef);
        this.successToast = false;
        this.commonBillingService.downloadBlob(res);
        console.log('File Downloaded');
      }
    }, (err)=>{
      clearTimeout(timeoutRef);
      this.successToast = false;
      this.toastMsg = "Report can't be downloaded at the moment"; 
      this.showTimeoutError = true;
      const timeoutErrRef = setTimeout(() => {
        this.showTimeoutError = false;
      }, 3000);
    })
  }

  uploadAVAConfiguration(){
    console.log("uploaded");  
  }
}
